module.exports = __webpack_public_path__ + "img/ic_feedback_nor.798e7e24.svg";